import { getAntdTheme as getGeneratedAntdTheme } from '@env0/ui-theme/antd';
import type { ThemeConfig } from 'antd';
import type { Env0Theme } from './themes.constants';
import { getLegacyAntdTheme } from './antd.constants.legacy';

export const getAntdTheme = (theme: Env0Theme): ThemeConfig =>
  theme.isNewDesign ? getGeneratedAntdTheme(theme.mode) : getLegacyAntdTheme(theme);
